import linkEvents from "../../modules/social/MobxReduxEventBus";
import {userReducer} from "../../common/auth/UserState";
import {configReducer} from "../../common/auth/ConfigState";
import settingsReducer from "../../modules/social/Settings/settingsReducer";
import {channelReducer} from "../../modules/social/channelReducer";
import ChatterChannel from "../../modules/social/ChatterChannel";
import {manageToolReducer} from "../chatmeteradmin/manageTool/manageToolReducer";
import {createStore, combineReducers} from "redux"
import {scoreSettingsReducer} from "../scores/manageScore/scoreSettingsReducer";


function createReduxStore() {
  const store = createStore(combineReducers({
      user: userReducer,
      config: configReducer,
      settings: scoreSettingsReducer, // TODO - find usages and call me something less generic
      channel: channelReducer,
      chatter: combineReducers({
        settings: settingsReducer,
      }),
      manageTool: manageToolReducer
    }),
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  )
  store.dispatch({
    type: 'SET_CHATTER_CHANNEL',
    channel: new ChatterChannel(store)
  })

  linkEvents(store)
  return store
}

export const reduxStore = createReduxStore()
